<template>
    <div>
        <v-container></v-container>
        <v-card>
            <v-toolbar dark color="secondary">
                <v-spacer></v-spacer>                
                <v-toolbar-title>Market Region List</v-toolbar-title>
                <v-spacer></v-spacer>                
                <!-- 20190318, hide this feature for now -->
                <v-btn small @click.prevent="onCreateNewRegion()" class="primary" v-if="userData.userName == 'jshi'">Add Region</v-btn>
            </v-toolbar>
            <!-- <v-card-text>
                <v-layout>
                    <v-flex xs12 class="text-xs-center">
                    </v-flex>

                </v-layout>
            </v-card-text> -->
            <v-card-text>
                <ctlRegions :regions="regions"
                    @onShowTerritoryCard="onShowTerritoryCard"
                    @onEditTerritory="onEditTerritory"
                    @onEditRegion="onEditRegion"
                    @reloadRegions="loadRegions"></ctlRegions>
            </v-card-text>

        </v-card>
        <v-dialog v-model="showTerritoryPopup" width="400" height="500">
            <ctlTerritoryCard 
                :territory="territoryToShow"
                :showCloseButton="true"
                @onCloseTerritoryCard="onCloseTerritoryCard"
                @onEditTerritory="onEditTerritory"
                @onTerritorySaved="onTerritorySaved"
                ></ctlTerritoryCard>
        </v-dialog>
        <v-dialog v-model="showTerritoryEditPopup" persistent width="400" height="500">
            <ctlTerritoryEdit 
                :id="territoryIdToEdit"
                @onCloseTerritoryEdit="onCloseTerritoryEdit"
                ></ctlTerritoryEdit>
        </v-dialog>

        <v-dialog v-model="showRegionEditPopup" width="400" height="500">
            <ctlRegionEdit 
                :id="regionIdToEdit"
                @onCloseRegionEdit="onCloseRegionEdit"
                ></ctlRegionEdit>
        </v-dialog>

    </div>

</template>
<script>
import ctlRegions from '@/components/admin/ctlRegions'
import ctlTerritoryCard from '@/components/admin/ctlTerritoryCard'
import ctlTerritoryEdit from '@/components/admin/ctlTerritoryEdit'
import ctlRegionEdit from '@/components/admin/ctlRegionEdit'
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        'ctlRegions': ctlRegions,
        'ctlTerritoryCard': ctlTerritoryCard,
        'ctlTerritoryEdit': ctlTerritoryEdit,
        'ctlRegionEdit': ctlRegionEdit,
    },
    data () {
        return {
            regions: [],
            territoryToShow: {},
            territoryIdToEdit: null,
            showRegionEditPopup: false,
            regionIdToEdit: null,
        }
    },
    computed: {
        ...mapGetters('auth', [
            'userData'
        ]),
        showTerritoryPopup () {
            return !!this.territoryToShow.id
        },
        showTerritoryEditPopup () {
            return !!this.territoryIdToEdit
        },
    },
    methods: {
        ...mapActions('adminMarket', [
            'getAllRegions'
        ]),
        onCreateNewRegion () {
            this.showRegionEditPopup = true
            // this.$router.push({name: 'admin-region-new'})
        },
        async loadRegions () {
            this.regions = await this.getAllRegions()
        },
        onEditRegion(id) {
            this.showRegionEditPopup = true
            this.regionIdToEdit = id
        },

        onCloseRegionEdit() {
            this.showRegionEditPopup = false
            this.regionIdToEdit = null
            this.loadRegions()
        },
        onCloseTerritoryEdit() {
            this.territoryIdToEdit = null
            this.loadRegions()
        },
        onShowTerritoryCard(territory) {
            this.territoryToShow = territory
        },
        onCloseTerritoryCard() {
            this.territoryToShow = {}
        },
        onTerritorySaved() {
            this.territoryToShow = {}
            this.loadRegions()
        },
        onEditTerritory(id) {
            this.territoryIdToEdit = id
            this.territoryToShow = {}
        },

    },
    async created () {
        this.loadRegions()
    }
}
</script>
